// ─── Drilldown Group By Feature allowlists ───────────────────────────
// Curated product lists: Type='Drilldown' Feature values that data-sync publishes
// AND that the Drilldown grouping CASE can resolve. Not the CASE labels themselves
// — those include every `Similar *` variant, which the UI deliberately hides
// because they expose internal cluster IDs.
//
// `GET /drilldown/group-by-options` filters `features_mapping` rows against these
// before caching, so a mapping reload cannot surface an unsupported Group By
// that would silently fall through the CASE ELSE. The workspace guard test
// asserts each list is a subset of the matching SEGMENT_EXPRESSIONS labels.

export const DRILLDOWN_GROUP_BY_FEATURES_ALL = [
  'Hash',
  'Exact Text Overlay (Hook)',
  'Exact Voice Over (Hook)',
  'Exact Text Overlay (Post-Hook)',
  'Exact Voice Over (Post-Hook)',
  'Exact Visual (Hook)',
  'Exact Visual (Post-Hook)',
  'Full Text Overlay',
  'Full Voice Over',
  'Full Visual',
  'Ad ID',
  'Headline',
  'Primary',
  'Start Date',
  'Link',
  'Hook',
  'Body',
] as const;

export const DRILLDOWN_GROUP_BY_FEATURES_CORE = [
  'Client',
  'Account Name',
  'Ad Name',
  'Adset ID',
  'Adset Name',
  'Campaign Name',
  'Campaign ID',
] as const;

export const DRILLDOWN_GROUP_BY_FEATURES_COMP = ['Industry', 'Competitor'] as const;

export const DRILLDOWN_GROUP_BY_FEATURES_MY_BRAND = [
  ...DRILLDOWN_GROUP_BY_FEATURES_ALL,
  ...DRILLDOWN_GROUP_BY_FEATURES_CORE,
] as const;

export const DRILLDOWN_GROUP_BY_FEATURES_COMPETITORS = [
  ...DRILLDOWN_GROUP_BY_FEATURES_ALL,
  ...DRILLDOWN_GROUP_BY_FEATURES_COMP,
] as const;
